<script setup lang="ts">
import PaymentGrossAmountGraph from 'pejer/src/components/Chart/Payments/PaymentGrossAmountGraph.vue'
import PaymentStatusDonutChart from 'pejer/src/components/Chart/Payments/PaymentStatusDonutChart.vue'
import PejerGraphProvider from 'pejer/src/components/Chart/PejerGraphProvider.vue'
import SectionCard from 'pejer/src/components/ui/section-card/SectionCard.vue'
import SectionCardHeader from 'pejer/src/components/ui/section-card/SectionCardHeader.vue'
import { formatMoney } from 'pejer/src/helpers'
import { PejerTablesList } from 'pejer/src/types/base'
import { Filters } from 'pejer/src/types/types'
import { MaybeRef } from 'vue'
import { usePejerBase } from '../../stores/pejerData'
import DataStateDisplay from '../DataState/DataStateDisplay.vue'
const pejer = usePejerBase()

defineProps<{
  query?: MaybeRef<Filters<PejerTablesList<'payments'>>>
}>()
</script>
<template>
  <div class="grid grid-cols-5 gap-2">
    <PejerGraphProvider
      :query="query"
      v-slot="{ data, dataState }"
      :url="pejer.urls.payments.stats"
      groupBy="month"
    >
      <div class="flex flex-col gap-2 h-full col-span-3">
        <div class="flex gap-2 w-full">
          <SectionCard class="flex-1">
            <SectionCardHeader class="w-full"> Total Payments Created </SectionCardHeader>
            <DataStateDisplay :="dataState">
              {{
                formatMoney(
                  data?.reduce((acc, item) => acc + item.count, 0),
                  false
                )
              }}
            </DataStateDisplay>
          </SectionCard>
          <SectionCard class="flex-1">
            <SectionCardHeader class="w-full"> Total Transaction Volume </SectionCardHeader>
            <DataStateDisplay :="dataState">
              {{
                formatMoney(data?.reduce((acc, item) => acc + item.totalTransactionVolume, 0) / 100)
              }}
            </DataStateDisplay>
          </SectionCard>
        </div>
        <SectionCard class="flex flex-col gap-4 col-span-3">
          <SectionCardHeader class="w-full"> Transaction Volume over time </SectionCardHeader>
          <div class="flex-grow h-0 flex-1">
            <PaymentGrossAmountGraph :data="data" />
          </div>
        </SectionCard>
      </div>
      <SectionCard class="h-full flex items-center col-span-2">
        <PaymentStatusDonutChart :data="data" />
      </SectionCard>
    </PejerGraphProvider>
  </div>
</template>
